const safeId = value => {
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : null;
};

export const catalogPlaceSource = place => {
  if (place?.catalogSource === "db" || place?.catalogSource === "legacy") return place.catalogSource;
  // Backward-compatible fallback: persisted restaurant rows carry moderation/category fields;
  // the original curated catalog does not.
  if (place?.moderationStatus !== undefined || place?.moderation_status !== undefined || place?.primaryCategory || place?.primary_category) return "db";
  return "legacy";
};

export const catalogPlaceSignalRef = place => {
  const id = safeId(place?.id);
  if (!id) return null;
  const source = catalogPlaceSource(place);
  return {
    key: `${source}:${id}`,
    placeId: source === "db" ? id : null,
    name: String(place?.name || "").trim(),
    location: String(place?.location || "").trim(),
  };
};

export const loadCatalogPlaceSignals = async ({ supabase, userId, place }) => {
  const ref = catalogPlaceSignalRef(place);
  if (!supabase || !userId || !ref) return { wantToTry: false, visualRating: 0 };
  const { data, error } = await supabase
    .from("place_user_signals")
    .select("want_to_try,visual_rating")
    .eq("user_id", userId)
    .eq("place_key", ref.key)
    .maybeSingle();
  if (error) throw error;
  return {
    wantToTry: !!data?.want_to_try,
    visualRating: Number(data?.visual_rating) || 0,
  };
};

export const persistCatalogPlaceInterest = async ({ supabase, place, wantToTry }) => {
  const ref = catalogPlaceSignalRef(place);
  if (!supabase || !ref) throw new Error("Lugar no disponible para guardar esta señal");
  const { error } = await supabase.rpc("set_catalog_place_interest", {
    p_place_key: ref.key,
    p_place_id: ref.placeId,
    p_place_name: ref.name,
    p_location: ref.location,
    p_want_to_try: !!wantToTry,
  });
  if (error) throw error;
};

export const persistCatalogPlaceFirstImpression = async ({ supabase, place, visualRating }) => {
  const ref = catalogPlaceSignalRef(place);
  if (!supabase || !ref) throw new Error("Lugar no disponible para guardar esta señal");
  const rating = Number(visualRating);
  if (!Number.isInteger(rating) || rating < 1 || rating > 5) throw new Error("La primera impresión debe estar entre 1 y 5");
  const { error } = await supabase.rpc("set_catalog_place_first_impression", {
    p_place_key: ref.key,
    p_place_id: ref.placeId,
    p_place_name: ref.name,
    p_location: ref.location,
    p_visual_rating: rating,
  });
  if (error) throw error;
};
